export default function toLocaleString(input: any) {
  if (!input) {
    return input;
  }
  return (input).toLocaleString(navigator.language);
}
